import materials from '@/public/materials/materials.json';

export const getAllMaterials = () => {
  return materials as unknown as {
    [key: string]: {
      name: string;
      description: string;
      image: string;
      icon: string;
      video: string;
    };
  };
};
